import React from 'react';
import { StarOutlined, StarFilled } from '@ant-design/icons';

import { FavouriteStarButton } from './FavouriteStar.styles';

interface FavouriteStarProps {
  size?: 'small' | 'middle' | 'large';
  isFavourite: boolean;
  onToggle?: (e) => void;
  className?: string;
  disabled?: boolean;
}

const FavouriteStar: React.FC<FavouriteStarProps> = ({
  isFavourite,
  size = 'middle',
  onToggle,
  className,
  disabled,
  ...rest
}) => {
  return (
    <FavouriteStarButton
      type="text"
      icon={isFavourite ? <StarFilled className="star-filled" /> : <StarOutlined className="star-outlined" />}
      onClick={onToggle}
      size={size}
      $isFavourite={isFavourite}
      className={className}
      disabled={disabled}
      {...rest}
    />
  );
};

export default FavouriteStar;
